export default (node) => {
  /**
   * Data + elements
   */
  const el = node.querySelector('[data-variant-dimensions-abbreviated]');
  const data = JSON.parse(
    document.getElementById('variant-metafields')?.textContent || '{}'
  );

  /**
   * Update function
   */
  const update = (variantId) => {
    const variantData = data?.[String(variantId)];
    if (el) {
      el.innerHTML = variantData?.dimensions_abbreviated || '';
    }
  };

  /**
   * Init
   */
  const init = () => {
    if (!el) return;

    // On page load
    const defaultId = document.querySelector(
      '[data-default-product-variant-id]'
    )?.dataset.defaultProductVariantId;
    if (defaultId) update(defaultId);

    // On variant change
    document.addEventListener('variant:change', (e) => {
      const id = e.detail?.variantId;
      if (id) update(id);
    });
  };

  init();
};
